// extracted by mini-css-extract-plugin
export default {"container":"qo-z","heading":"ro-z","text":"so-z","info":"to-z","link":"uo-z","fullMaxWidth":"vo-z"};